// import React, { useEffect, useState } from "react";
// import Axios from "../../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Notification from "../../Notification";


import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";

import ReactPaginate from 'react-paginate';
import UpdateServiceName from './UpdateServiceName';

// import Notification from "../Notification";
// import { Link } from "@material-ui/core";




const ServiceList = () => {
    const [serviceName, setServiceName] = useState('');
    const [editName, setEditName] = useState(false);
    const [serviceId, setServiceId] = useState('1');

    // const Navigate = useNavigate();
    const [service_details, setServiceDetails] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [sortToggle, setSortToggle] = useState(true);

    const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE);

    const [searchData, setSearchData] = useState('');

    const [once, setOnce] = useState([]);
    const [isNameUpdated, setIsNameUpdated] = useState(false);




    const getServiceList = async () => {
        let res;
        if (searchData) {
            res = await Axios.get(`api/bussiness/service-listing?searchData=${searchData}`);
            console.log(res);
        }
        else {
            res = await Axios.get(`api/bussiness/service-listing?pageNo=1&perPage=${perPage}`);
        }
        setServiceDetails(res.data.data.data);
        console.log(service_details);
        setTotalPage(res.data.data.totalPage);
        setpageCount(res.data.data.totalPage);
        setIsNameUpdated(false);
        console.log(totalPages, pageCount);
        localStorage.removeItem('sort_key');
        localStorage.removeItem('sort_order');
    };

    useEffect(() => {
        getServiceList();
    }, [once, perPage]);

    useEffect(() => {
        if (isNameUpdated) {
            getServiceList();
        }
    }, [isNameUpdated])



    const fetchServiceList = async (currentPage) => {
        const sort_key = localStorage.getItem('sort_key');
        const sort_order = localStorage.getItem('sort_order');
        let sortUrl = "";
        if (sort_key && sort_order) {
            sortUrl = `&sortkey=${sort_key}&order=${sort_order}`;
        }
        const res = await Axios.get(`api/bussiness/service-listing?pageNo=${currentPage}&perPage=${perPage}${sortUrl}`);
        await setServiceDetails(res.data.data.data);
        return service_details;
    };


    const handlePageClick = async (data) => {
        let currentPage = data.selected + 1;
        await fetchServiceList(currentPage);
    };





    const handleChange = (e) => {
        const { name, checked } = e.target;
        // console.log(name);


        if (name === "allSelect") {
            let tempUser = service_details.map((plan) => {
                return { ...plan, isChecked: checked };
            });
            console.log(tempUser);
            setServiceDetails(tempUser);
        }
        else {
            let tempUser = service_details.map((plan) =>
                plan.service_id === name ? { ...plan, isChecked: checked } : plan
            );
            console.log(tempUser);
            setServiceDetails(tempUser);
        }
    }





    function HandleEditName(e) {
        console.log(e.target.value);
        setServiceId(e.target.value);
        console.log(service_details.length);
        for (let i = 0; i < service_details.length; i++) {
            if (service_details[i].service_id === e.target.value) {
                setServiceName(service_details[i].service_name);
            }
        }
        setEditName(true);
    }








    const DeleteApi = (e) => {
        console.log(service_details);
        const serviceIds = [];
        if (e.target.value) {
            serviceIds.push(e.target.value);
        }
        for (let i = 0; i < service_details.length; i++) {
            if (service_details[i].isChecked === true) {
                serviceIds.push(service_details[i].service_id);
            }
        }
        console.log(serviceIds);
        Axios
            .post("api/bussiness/service-delete", {
                serviceIdsArr: serviceIds
            }).then((res) => {
                console.log(res);
                getServiceList();
            }).catch((error) => {
                console.log(error);
            })

    }








    const Serviceitem = service_details.map((plan, index) => {
        return (
            <tr key={index} value={plan.service_id}>
                <td><input
                    type="checkbox"
                    name={plan.service_id}
                    checked={plan?.isChecked || false}
                    onChange={handleChange}
                />
                </td>
                <td>{index + 1}</td>
                <td>{plan.service_name}</td>
                <td>{plan.service_id}</td>
                <td>{plan.added_by}</td>
                <td>{plan.added_date}</td>
                <td>{plan.status}</td>
                <td >
                    <button value={plan.service_id} name={plan.service_name} onClick={(e) => HandleEditName(e)}>Edit </button>
                    <button value={plan.service_id} onClick={(e) => DeleteApi(e)}>Delete</button>
                </td>
            </tr>
        )
    })


    const handleSortdesc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey, order);
            // alert('I am Decending')
            setSortToggle(true);
            localStorage.setItem("sort_key", sortkey);
            localStorage.setItem("sort_order", order);
            const res = await Axios.get(`api/bussiness/service-listing?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setServiceDetails(res.data.data.data);
                // setSortToggle(true);
            }
        }
    }



    const handleSortasc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey)
            // alert('I am accending')
            setSortToggle(false);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/bussiness/service-listing?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setServiceDetails(res.data.data.data);
            }
        }
    }



    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Service List</h4>
                                </div>
                            </div>
                        </div>

                        <div style={{ position: "absolute", right: "30px" }}>
                        </div>

                        <div className="col-md-6 col-xl-3">
                            <div className="card-box">
                                <div className="form-group mb-0 text-center">
                                    <input type="" className='search-product-box' placeholder='Search...'
                                        onChange={(e) => setSearchData(e.target.value)}
                                    />

                                    <button onClick={getServiceList}>Search</button>
                                </div>
                            </div>

                        </div>
                        {
                            editName ? <UpdateServiceName setIsNameUpdated={setIsNameUpdated} setEditName={setEditName} serviceId={serviceId} serviceName={serviceName} /> : ""
                        }

                        <div className="row">
                            <div className="card-box table-responsive">
                                <h4 className="header-title"><b>List of Active Services</b></h4>
                                {/* <!-- <p className="sub-header">
                                            Show Listing</code>.
                                        </p> --> */}
                                <button onClick={DeleteApi}>All Delete</button>
                                {
                                    totalPages === 0 ?
                                        <h1>Data Not found</h1>
                                        :
                                        <table id="datatable" className="table table-bordered  dt-responsive nowrap">
                                            <thead>
                                                <tr>
                                                    <td><input
                                                        type="checkbox"
                                                        name="allSelect"
                                                        checked={!service_details.some((plan) => plan?.isChecked !== true)}
                                                        onChange={handleChange}
                                                    />allSelect
                                                    </td>
                                                    <td>S.No</td>
                                                    <td >Service Name
                                                    </td>
                                                    <td>Service Id
                                                    </td>
                                                    <td>Added By
                                                    </td>
                                                    <td>Added Date
                                                    </td>
                                                    <td>Status
                                                    </td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>


                                            <tbody>

                                                {Serviceitem}

                                            </tbody>

                                        </table>
                                }
                                <ReactPaginate
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    breakLabel={"..."}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination justify-content-center"}
                                    pageClassName={"page-item"}
                                    pageLinkClassName={"page-link"}
                                    previousClassName={"page-item"}
                                    previousLinkClassName={"page-link"}
                                    nextClassName={"page-item"}
                                    nextLinkClassName={"page-link"}
                                    breakClassName={"page-item"}
                                    breakLinkClassName={"page-link"}
                                    activeClassName={"active"}
                                />
                                <span><b>Rows per page:-</b></span>
                                <select name="Rows per page" onChange={(e) => setPerpage(e.target.value)}>
                                    <option>Select Per Page</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="60">60</option>
                                </select>
                            </div>

                        </div>

                    </div>
                </div>


            </div>

        </>

    )
}

export default ServiceList;